import { Box } from "@mui/material";

const FilterBar = ({
    children,
    gap = 2,
    align = "center",
    justify = "flex-start",
    sx = {},
    ...props
}) => {
    return (
        <Box
            {...props}
            sx={(theme) => ({
                display: "flex",
                flexWrap: "wrap",
                gap: theme.spacing(gap),
                alignItems: align,
                justifyContent: justify,
                width: "100%",
                "& .MuiButton-root": {
                    flexShrink: 0,
                },
                [theme.breakpoints.down("sm")]: {
                    gap: theme.spacing(1),
                    alignItems: "stretch",
                    "& .MuiButton-root": {
                        width: "100%",
                    },
                },
                ...sx,
            })}
        >
            {children}
        </Box>
    );
};

export default FilterBar;
